module.exports = __webpack_public_path__ + "img/send_icon.cd2a82dc.svg";